import React, { Component } from 'react';
import InlineField from './InlineField';

import Message from './ValidationMessage';

export class RadioBoxField extends Component {
  render() {
    const { fieldId, input, required, label, disabled, displayType,checked, meta: { touched, error, warning } } = this.props;
    let showError = touched && error ? "error" : "";

    if ( displayType === 'inline' ) {      
      return <InlineField fieldType='renderCheckBox' content={ input.value } label={label} />;
    }

    return (
      <div className={`${required && 'required'} field ${showError}`}>
        <div id={fieldId} className="ui radio checkbox">
          <input {...input} type="radio" disabled={disabled} checked={checked}/>
          <label>{label}</label>
        </div>
        <Message show={touched} message={error} />
        <Message show={touched} message={warning} />
      </div>
    );
  }

}
